import { createTheme, type MantineColorsTuple } from '@mantine/core';

// TransPay brand palette — azure blue taken from the logo's paper-plane mark
// (#2e8be6) deepening to the wordmark's "Pay" blue (#0e63c0). Shade 6 is the
// default filled tone; 0–1 are the pale logo accents, 8–9 the deep blues.
const brand: MantineColorsTuple = [
  '#e7f2ff',
  '#d0e2f7',
  '#a3c8f0',
  '#74abe9',
  '#4a93e8',
  '#3486e4',
  '#2e8be6',
  '#1d72cf',
  '#0e63c0',
  '#084d9b',
];

export const transpayTheme = createTheme({
  primaryColor: 'brand',
  defaultRadius: 'md',
  fontFamily: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  headings: {
    fontWeight: '600',
  },
  colors: {
    brand,
  },
  components: {
    Card: {
      defaultProps: {
        withBorder: true,
        shadow: 'xs',
      },
    },
    Table: {
      defaultProps: {
        striped: false,
        highlightOnHover: true,
        verticalSpacing: 'xs',
        horizontalSpacing: 'md',
      },
    },
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
  },
});
